/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import CancelIcon from "@mui/icons-material/Cancel";
import { Card, CardContent, CardHeader, IconButton, Tab, Tabs } from "@mui/material";
import { ModalPopUp, MuiTooltip } from "@pionglobal/pionsharedui";
// -------------------------------------------------------------------------------------
const CommonDashboardViewReport = ({
  mediumScreen,
  smallScreen,
  largeScreen,
  customWidth,
  heading,
  close,
  children,
  veryBigScreen,
  aiScreen,
  maxHeight,
  tabs,
  selectedTab,
  onTabChange,
  ...props
}) => {

  let computedWidth;
  if (largeScreen) {
    computedWidth = "76.5vw";
  } else if (mediumScreen) {
    computedWidth = "60vw";
  } else if (smallScreen) {
    computedWidth = "45vw";
  } else {
    computedWidth = customWidth || "76.5vw";
  }
  let containerMarginLeft = "15vw";

  if (smallScreen) {
    containerMarginLeft = "32vw";
  } else if (mediumScreen) {
    containerMarginLeft = "27vw";
  }

  return (
    <ModalPopUp open={true}>
      <Card
        style={{
          width: computedWidth,
          marginTop: "8.5vh",
          marginLeft: containerMarginLeft,
          position: "relative",
        }}
        className="res_update_uc"
      >
        {(tabs || close) && (
          <CardHeader
            title={
              tabs && (
                <Tabs
                  value={selectedTab}
                  onChange={onTabChange}
                  aria-label="dashboard tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                >
                  {tabs.map((tab, index) => (
                    <Tab key={tab} label={tab} />
                  ))}
                </Tabs>
              )
            }
            action={
              close && (
                <div
                  style={{
                    position: "absolute",
                    top: "-0.3rem",
                    right: "0rem",
                  }}
                >
                  <MuiTooltip title="close">
                    <IconButton aria-label="cancel" onClick={() => close()}>
                      <CancelIcon color="red" />
                    </IconButton>
                  </MuiTooltip>
                </div>
              )
            }
            sx={{
              paddingBottom: "0px!important",
              textAlign: "center", // Center the CardHeader content
            }}
          />
        )}

        <CardContent
          style={{ maxHeight: maxHeight ?? "85vh", overflow: "auto" }}
        >
          {children}
        </CardContent>
      </Card>
    </ModalPopUp>
  );
};

export default CommonDashboardViewReport;
